/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Indicates which level of domestic push-to-card transfer is supported by the card, if any.
 */
export const DomesticPushToCard = {
  NotSupported: "not-supported",
  Standard: "standard",
  FastFunds: "fast-funds",
  Unknown: "unknown",
} as const;
/**
 * Indicates which level of domestic push-to-card transfer is supported by the card, if any.
 */
export type DomesticPushToCard = ClosedEnum<typeof DomesticPushToCard>;

/** @internal */
export const DomesticPushToCard$inboundSchema: z.ZodNativeEnum<
  typeof DomesticPushToCard
> = z.nativeEnum(DomesticPushToCard);
/** @internal */
export const DomesticPushToCard$outboundSchema: z.ZodNativeEnum<
  typeof DomesticPushToCard
> = DomesticPushToCard$inboundSchema;
